import { render, staticRenderFns } from "./LugarPage.vue?vue&type=template&id=64ed98de"
import script from "./LugarPage.js?vue&type=script&lang=js&external"
export * from "./LugarPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports